import { render, staticRenderFns } from "./SetEditor.vue?vue&type=template&id=b9ca4718&scoped=true&"
import script from "./SetEditor.vue?vue&type=script&lang=js&"
export * from "./SetEditor.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/forms.css?vue&type=style&index=0&id=b9ca4718&prod&scoped=true&lang=css&"
import style1 from "./SetEditor.vue?vue&type=style&index=1&id=b9ca4718&prod&scooped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ca4718",
  null
  
)

export default component.exports